__turbopack_context__.v({
  "component": "sticky-footer-module-scss-module__KzxTga__component",
  "container": "sticky-footer-module-scss-module__KzxTga__container",
  "secondaryActions": "sticky-footer-module-scss-module__KzxTga__secondaryActions",
});
